import { Tooltip } from '@chakra-ui/react'
import useGA4DataLayer from '@common/hooks/use-ga4-data-layer'
import { Cart } from '@medusajs/medusa'
import Button from '@modules/common/components/button'
import CartTotals from '@modules/common/components/cart-totals'
import Link from 'next/link'

type SummaryProps = {
  cart: Omit<Cart, 'refundable_amount' | 'refunded_total'>
  isOutOfStock: boolean
}

const Summary = ({ cart, isOutOfStock }: SummaryProps) => {
  return (
    <div className="grid grid-cols-1 gap-y-6">
      <CartTotals cart={cart} />
      <Link href="/checkout">
        <Tooltip
          label="Some products in cart out of stock"
          display={isOutOfStock ? 'block' : 'none'}
        >
          <div>
            <Button disabled={isOutOfStock}>Go to checkout</Button>
          </div>
        </Tooltip>
      </Link>
    </div>
  )
}

export default Summary
